<template>
  <fieldset>
    <legend class="sr-only">Choisir une option</legend>

    <div class="flex" :class="[{ 'flex-col': variant === 'radios' }, classWrapper]">
      <BaseRadio
        v-for="(option, index) in options"
        :key="option.key"
        :checked="option.key == modelValue"
        :variant="variant"
        :option="option"
        :name="uuid"
        :class="[
          {
            'tab-radio-component border border-r-0 py-3 px-3 flex items-center justify-center text-sm font-medium text-center sm:flex-1 cursor-pointer':
              variant === 'tabs',
            'bg-jva-blue-600 border-transparent text-white hover:bg-jva-blue-500 nicochecked':
              variant === 'tabs' && option.key == modelValue,
            'bg-white border-gray-200 text-gray-900 hover:bg-gray-50 ninotchecked':
              variant === 'tabs' && option.key != modelValue,
            '!border-r-0': variant === 'tabs' && index == 0,
            '!border-r !border-l': variant === 'tabs' && index == options.length - 1,
            '!border-l-0': variant === 'tabs' && index == options.length - 1 && options.length > 2,
          },
        ]"
        @update="onUpdateValue"
      />
    </div>
  </fieldset>
</template>

<script>
export default defineNuxtComponent({
  emits: ['update:modelValue'],
  props: {
    options: { type: Array, required: true },
    modelValue: { type: [String, Number, Boolean], default: null },
    variant: {
      type: String,
      default: 'radios',
      validator: (s) => ['radios', 'tabs'].includes(s),
    },
    classWrapper: { type: String, default: '' },
  },
  setup() {
    return {
      uuid: useId(),
    }
  },
  computed: {},
  methods: {
    onUpdateValue(payload) {
      this.$emit('update:modelValue', payload)
    },
  },
})
</script>

<style lang="postcss" scoped>
.tab-radio-component {
  outline: none !important;

  &:focus-within {
    outline-style: solid !important;
    outline-color: #0a76f6 !important;
    outline-width: 2px !important;
    outline-offset: 2px !important;
  }
}
</style>
